<template>
    <div class="container">
        <div class="handle-box-search">
            <div class="handle-box" style="display: flex">
                <el-row class="head-search">
                    <div style="margin: 10px 0; display: flex" class="search-radio fs-big">
                        <div>
                            <div class="title">扣费时间</div>
                            <el-radio-group v-model="order_fixed_time_value" size="small" @change="dataChange">
                                <el-radio label="yesterday" border style="margin-right: 40px">昨天</el-radio>
                                <el-radio label="between" border style="margin-right: -9px">自定义时间</el-radio>
                            </el-radio-group>
                        </div>

                        <el-date-picker
                            v-model="search_time"
                            type="datetimerange"
                            range-separator="-"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            format="yyyy-MM-dd HH:mm:ss"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            @change="timeChange"
                            style="width: 370px"
                        />
                    </div>
                </el-row>
            </div>
            <el-button type="primary" icon="el-icon-search" @click="searchgetCityplatformFee" class="btn1">搜索</el-button>
            <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>
            <el-button :icon="progress_show ? 'el-icon-loading' : 'el-icon-setting'" @click="toExport" :disabled="progress_show">
                {{ progress_show ? '导出中...' : '导出' }}
            </el-button>

            <div style="width: 500px; margin: 10px auto" v-if="progress_show">
                <el-progress :percentage="progress_data"></el-progress>
                <i class="el-icon-loading"></i>
                正在导出...
            </div>
        </div>

        <div class="searchInfo">
            <div style="margin: 20px; display: flex; justify-content: left; color: #606266; margin-left: 10px">
                <div style="margin-right: 50px">抽成订单总数: {{ count }}</div>
                <div style="margin-right: 50px">抽成总额: {{ amount }}</div>
            </div>
            <div>
                <el-table
                    v-loading="loading"
                    element-loading-text="加载中..."
                    :data="tableData"
                    class="table"
                    ref="multipleTable"
                    header-cell-class-name="table-header"
                >
                    <el-table-column prop="amount" label="金额"></el-table-column>
                    <el-table-column prop="billno" label="订单号"></el-table-column>
                    <el-table-column prop="description" label="描述"></el-table-column>
                    <el-table-column prop="name" label="司机姓名"></el-table-column>
                    <el-table-column prop="phone" label="电话号码"></el-table-column>
                    <el-table-column prop="time_stamp" label="扣费时间"></el-table-column>
                </el-table>
            </div>
            <div class="pagination">
                <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>
            </div>
        </div>
    </div>
</template>

<script>
var _this;

export default {
    data() {
        return {
            order_fixed_time_value: 'yesterday',
            amount: '',
            count: '',
            search_time: [],
            tableData: [],
            loading: false,
            excelData: [],
            progress_show: false,
            progress_data: 0,
            search_data: {
                page: 1,
                limit: 10,
                fixed_array: ''
            },
            result_data: [],
            search_rules: {
                page: {
                    placeholder: '页码',
                    rules: {
                        required: true,
                        message: '页码需要大于0',
                        regulation: 'gt',
                        rulesData: 0
                    }
                },
                limit: {
                    placeholder: '每页条数',
                    rules: {
                        required: true,
                        message: '每页条数需在1到51之间',
                        regulation: 'between',
                        rulesData: [1, 51]
                    }
                }
            }
        };
    },
    created() {
        _this = this;
        _this.search_data.fixed_array = JSON.stringify([_this.order_fixed_time_value]);
        _this.getCityplatformFee();
    },
    methods: {
        dataChange(val) {
            _this.search_time = [];
            _this.search_data.fixed_array = val == 'between' ? JSON.stringify(['between']) : JSON.stringify([_this.order_fixed_time_value]);
        },
        timeChange(val) {
            _this.order_fixed_time_value = '';
            _this.search_data.fixed_array = val != null ? JSON.stringify(['between', ..._this.search_time]) : '';
        },
        searchgetCityplatformFee() {
            _this.search_data.page = 1;
            _this.getCityplatformFee();
        },
        getCityplatformFee() {
            _this.loading = true;
            _this
                .$post('/statistics/getCityplatformFee', _this.search_data, _this.search_rules)
                .then((res) => {
                    _this.tableData = res.data.result;
                    _this.result_data = res.data;
                    _this.amount = res.data.amount;
                    _this.count = res.data.count;
                    _this.loading = false;
                })
                .catch(() => {
                    _this.loading = false;
                });
        },
        toExport() {
            _this.progress_show = true;
            _this.progress_data = 0;
            _this.excelData = [];
            _this.search_data.page = 1;
            _this.search_data.limit = 50;
            _this.getExcelData();
        },
        getExcelData() {
            _this
                .$post('/statistics/getCityplatformFee', _this.search_data, _this.search_rules)
                .then((res) => {
                    const list = res.data.result || [];
                    list.forEach((item) => {
                        _this.excelData.push({
                            amount: item.amount,
                            billno: item.billno,
                            description: item.description,
                            name: item.name,
                            phone: item.phone,
                            time_stamp: item.time_stamp
                        });
                    });

                    if (res.data.page * res.data.limit < res.data.count) {
                        _this.search_data.page = res.data.page + 1;
                        _this.progress_data = Math.floor(((res.data.page * res.data.limit) / res.data.count) * 100);
                        _this.getExcelData();
                    } else {
                        _this.exportData();
                        _this.search_data.page = 1;
                        _this.progress_show = false;
                        _this.progress_data = 0;
                        _this.excelData = [];
                    }
                })
                .catch(() => {
                    _this.progress_show = false;
                    _this.progress_data = 0;
                });
        },
        exportData() {
            const { export_json_to_excel } = require('@/vendor/Export2Excel');
            const tHeader = ['金额', '订单号', '描述', '司机姓名', '电话号码', '扣费时间'];
            const filterVal = ['amount', 'billno', 'description', 'name', 'phone', 'time_stamp'];
            const data = this.formatJson(filterVal, this.excelData);
            export_json_to_excel(tHeader, data, '订单抽成统计');
        },
        formatJson(filterVal, jsonData) {
            return jsonData.map((v) => filterVal.map((j) => v[j]));
        },
        pages_function(search_data) {
            _this.search_data = search_data;
            _this.getCityplatformFee();
        },
        refresh() {
            this.$router.go(0);
        }
    }
};
</script>

<style scoped>
.search-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    max-width: 150px;
    display: inline-block;
    margin-left: 10px;
    margin-top: 10px;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.el-table__row {
    height: 100px;
}

.el-dropdown {
    vertical-align: top;
}

.el-dropdown + .el-dropdown {
    margin-left: 15px;
}

.el-icon-arrow-down {
    font-size: 12px;
}

.search-box {
    display: flex;
}

.searchBox {
    margin: 10px;
    padding: 30px 0;
    border-radius: 15px;
    background-color: #f5f7fa !important;
    border: 1px solid #dcdfe6;
}

.title {
    display: inline-block !important;
    width: 80px !important;
    text-align: right !important;
    padding-right: 5px !important;
    box-sizing: border-box !important;
    background-color: transparent !important;
    color: #000;
    font-size: 14px;
    margin-left: 10px;
    margin-bottom: 10px;
}

.btn1 {
    margin-left: 10px;
}
</style>
